import _ from 'lodash';
// eslint-disable-next-line import/no-cycle
import router from '@/router';
import lsManualRequestService from '@/services/manual-request/manual-request.service';
// eslint-disable-next-line import/no-cycle
import lsOrderService from '@/services/order/order.service';
// eslint-disable-next-line import/no-cycle
import lsTrackService from '@/services/ls-track/ls-track.service';
import * as types from '../types';

function googleTracking(route) {
    if (
        route === '/single-signup/form/out-of-market' ||
        route === '/single-signup/form/pricing-unavailable'
    ) {
        lsTrackService.sendGoogleAnalyticsPageview('/inactive-zip-quote-complete');
        lsTrackService.trackGoogleConversion({ id: 957569029, label: 'XJM0CIqw_2MQhbDNyAM' });
    } else if (route === '/single-signup/form/one-time-mowing') {
        lsTrackService.sendGoogleAnalyticsPageview('/one-time-quote-complete');
        lsTrackService.trackGoogleConversion({ id: 957569029, label: 'DFHtCJLw9GMQhbDNyAM' });
    }
}

const _private = {
    googleTracking,
};

const manualRequestModule = {
    state: {
        services: {
            recurring: false,
            'one-time': false,
            'clean-up': false,
            fertilization: false,
            aeration: false,
            other: false,
        },
        details: '',
        valid: false,
        submitting: false,
    },
    mutations: {
        [types.MANUAL_REQUEST__MUTATE_VALIDATION](localState, { valid }) {
            // eslint-disable-next-line no-param-reassign
            localState.valid = valid;
        },
        [types.MANUAL_REQUEST__MUTATE_MANUAL_REQUEST](localState, payload) {
            _.merge(localState, payload);
        },
    },
    actions: {
        [types.MANUAL_REQUEST__UPDATE_MANUAL_REQUEST]({ commit, state }, payload) {
            commit(types.MANUAL_REQUEST__MUTATE_MANUAL_REQUEST, payload);
            if (state.valid !== (!!state.details || _.some(_.values(state.services)))) {
                commit(types.MANUAL_REQUEST__MUTATE_VALIDATION, {
                    valid: !state.valid,
                });
            }
        },
        [types.MANUAL_REQUEST__SUBMIT_MANUAL_REQUEST]({ commit, rootState, dispatch }, payload) {
            const { contactInfo, manualRequest, order } = rootState;
            if (manualRequest.submitting) {
                return;
            }
            commit(types.MANUAL_REQUEST__MUTATE_MANUAL_REQUEST, { submitting: true });

            lsManualRequestService
                .generateNoteAndSubmit({ contactInfo, manualRequest, order })
                .then(() => {
                    _private.googleTracking(payload.path);
                    if (payload.path === '/single-signup/form/out-of-market') {
                        router.push({ path: '/single-signup/form/thanks/out-of-market' });
                    } else {
                        router.push({ path: '/single-signup/form/thanks' });
                    }
                    lsOrderService.clearStoredOrderData();
                    commit(types.MANUAL_REQUEST__MUTATE_MANUAL_REQUEST, { submitting: false });
                })
                .catch((err) => {
                    dispatch(types.ERROR__SET_ERROR, err);
                    commit(types.MANUAL_REQUEST__MUTATE_MANUAL_REQUEST, { submitting: false });
                });
        },
    },
};

export default manualRequestModule;
